import Alpine from "alpinejs";
import morph from "@alpinejs/morph";
import mask from "@alpinejs/mask";
import focus from "@alpinejs/focus";

import htmx from "htmx.org";
import "htmx-ext-alpine-morph";

globalThis.htmx = htmx;
globalThis.Alpine = Alpine;

Alpine.plugin(morph);
Alpine.plugin(mask);
Alpine.plugin(focus);
Alpine.start();